<template>
  <div>
    <div class="packBox">
      <div class="packItem u-flex" v-for="(items,index) in heatpackageList" :key="index">
        <div class="packItemImg">
          <img class="packimg"  :src="items.imgUrl" alt="" srcset="">
        <!--  <div class="packimgbiao">
            {{items.heatValid}}天
          </div> -->
          <!-- <img v-if='items.heatValid == 7' class="packimgbg" :src="items.imgUrl" alt="" srcset="">
          <img v-if='items.heatValid == 30' class="packimgbg" src="@/assets/img/30day.png" alt="" srcset=""> -->
        </div>
        <div class="packName u-flex-y u-flex-between">
          <div class="hotPackName">
            置顶包 <span>（{{items.price}}{{items.currencyType ==1?'龙币':'贝壳'}}）</span>
          </div>
          <div class="hotPackValue">
            获得{{items.heat}}热度（有效期<span>{{items.heatValid}}天</span>）
          </div>
        </div>
        <div class="packBuy" @click="bugHot(items)">
          <span>购买</span>
        </div>
      </div>
      <div class="hotdiscript u-flex u-flex-items-center">
        <img src="@/assets/img/hot.png" alt="" srcset="">
        <span>
          使用置顶包，可在一定范围内获得榜首机会，增加曝光！
        </span>
      </div>
      <div class="discript">
        *开播即获得固定热度，有效期越久排名越靠前
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {
    heatpackage,
    buyheatpackage
  } from '@/api/lz.js'
  export default {
    data() {
      return {
        heatpackageList: []
      }
    },
    created() {
      this.getheatpackage()
    },
    methods: {
      bugHot(items) {
        let that = this;
        buyheatpackage({
          id: items.id
        }).then(result => {
          if (result.data.code == 200) {
            console.log('购买效果', result.data.message);
            // that.$message.sucess(result.data.message)
            this.$emit('change')
            this.$message({
              message: result.data.message,
              type: 'success'
            });
          } else {
            this.$message({
              message: result.data.message,
              type: 'warning'
            });
          }
        })
      },
      getheatpackage() {
        heatpackage({}).then(result => {
          if (result.data.code == 200) {
            console.log('获取热度包', result);
            this.heatpackageList = result.data.data
          }
        })
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/flex.scss';



  .packBox {
    padding: 18px;
    width: 400px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .hotdiscript {
      margin-top: 7px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #F3561F;

      img {
        margin-right: 1px;
        width: 14px;
        height: 14px;
      }
    }

    .discript {
      margin-top: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }

    .packBuy {
      display: flex;
      justify-content: center;
      align-self: center;
      width: 96px;
      transition: all .25s;

      &:active {
        opacity: .5;
        transition: all .25s;
      }

      span {
        text-align: center;
        display: inline-block;
        width: 48px;
        height: 26px;
        line-height: 26px;
        background: #721EDC;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    .packItem {
      height: 60px;

      margin-bottom: 25px;

      .packName {
        padding: 4px 0 1px 12px;
        box-sizing: border-box;
        display: flex;
        flex: 2;

        .hotPackName {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;

          span {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF8729;
          }

          ;
        }

        .hotPackValue {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          span {
            color: #721EDC;
          }
        }
      }

      .packItemImg {
        position: relative;
        overflow: hidden;
        .packimgbiao{
          display: block;
          padding: 2px 14px;
          width: 40px;
          height: 14px;
          font-size: 10px;
          line-height: 14px;
          text-align: center;
          color: #fff;
          background-color:#721EDC ;
          transform:scale(0.78) rotate(-45deg)  ;
          position: absolute;
          top: 4px;
          left: -22px;
        }
        .packimg {
          width: 58px;
          height: 60px;
        }

        .packimgbg {
          position: absolute;
          left: 0;
          width: 58px;
          height: 60px;
        }
      }
    }

    .packItem:last-child {
      margin-bottom: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_topPack.vue